import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { ToolExecutionHar } from '@terra/shared-contracts-tracker';
import { terraProxyApiClient } from '../../clients/testerClient';

const HAR_BY_ID_QUERY_KEY = 'tool-execution-har-by-id';

const getHarById = async (id: string) => terraProxyApiClient.getToolHarById(id);

export const useHarById = () => {
  const queryClient = useQueryClient();

  const fetchHarById = useCallback(
    async (id: string): Promise<ToolExecutionHar | null> => {
      if (!id) {
        return null;
      }

      try {
        return await queryClient.fetchQuery({
          queryKey: [HAR_BY_ID_QUERY_KEY, id],
          queryFn: () => getHarById(id),
        });
      } catch {
        return null;
      }
    },
    [queryClient],
  );

  return {
    fetchHarById,
  };
};
